export const RESERVATION_TYPES = Object.freeze({
    NORMAL: 1,
    DISABLE: 2,
});